const REQUIRED_COOKIES__DATA_KEY = 'data-required-cookies'

export function readRequiredCookies(cookieOverlayElem) {
    return JSON.parse(cookieOverlayElem.getAttribute(REQUIRED_COOKIES__DATA_KEY))
}